import React, {Component} from "react";
import ReactModal from "react-modal";
import Input from "../../common/input";
import {dateToString, stringToDate} from "../../../services/dateTimeFormat";
import SelectByList from "../../common/selectByList";

class MobileShiftPlanningDataForm extends Component {
    constructor(props) {
        super();
    }

    onSchichtrad = () => {
        console.log("onSchichtrad")
        alert("Dieser Browser ist für diesen Entwicklungsmodus nicht zugelassen!")
    }

    render = () => {
        const {
            showModal, style, ariaHideApp,
            startActionDate, endActionDate,
            handleSaveAbsence, handleDeleteAbsence, handleSaveTimeTimeModel, handleDeleteTimeTimeModel, handleCloseModal,
            handleChangeAbsence, handleChangeTimeTimeModel, handleChangeStartActionDate, handleChangeEndActionDate,
            person, absenceList, timeTimeModelList,
            absenceId, timeTimeModelId
        } = this.props;
        return (
            <ReactModal
                isOpen={showModal}
                contentLabel="MobileShiftPlanningDataForm"
                style={style}
                ariaHideApp={ariaHideApp}
            >
                <table>
                    <tbody>
                    <tr>
                        <td><h4>{person.surname}</h4></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>
                            <Input
                                name={"startDate"}
                                label={"von"}
                                value={dateToString(
                                    stringToDate(startActionDate, "YYYYMMDD"),
                                    "YYYY-MM-DD"
                                )}
                                type={"date"}
                                onChange={handleChangeStartActionDate}
                            />
                            <Input
                                name={"endDate"}
                                label={"bis"}
                                value={dateToString(
                                    stringToDate(endActionDate, "YYYYMMDD"),
                                    "YYYY-MM-DD"
                                )}
                                type={"date"}
                                onChange={handleChangeEndActionDate}
                            />
                        </td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>
                            <SelectByList
                                name={absenceId}
                                label={"Abwesenheit"}
                                value={absenceId}
                                itemList={absenceList}
                                error={null}
                                handleItemSelect={handleChangeAbsence}
                                help={null}
                                autoFocus={null}
                            />
                        </td>
                        <td>
                            <div className="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
                                <div className="btn-group mr-2" role="group" aria-label="First group">
                                    <button
                                        className="btn btn-primary btn-sm"
                                        onClick={handleSaveAbsence}>
                                        Abwesenheit speichern
                                    </button>
                                </div>
                                <div className="btn-group mr-2" role="group" aria-label="Second group">
                                    <button
                                        className="btn btn-danger btn-sm"
                                        onClick={handleDeleteAbsence}>
                                        Abwesenheit löschen
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <SelectByList
                                name={timeTimeModelId}
                                label={"Tagesmodell"}
                                value={timeTimeModelId}
                                itemList={timeTimeModelList}
                                error={null}
                                handleItemSelect={handleChangeTimeTimeModel}
                                help={null}
                                autoFocus={null}
                            />
                        </td>
                        <td>
                            <div className="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
                                <div className="btn-group mr-2" role="group" aria-label="First group">
                                    <button
                                        className="btn btn-primary btn-sm"
                                        onClick={handleSaveTimeTimeModel}>
                                        Tagesmodell speichern
                                    </button>
                                </div>
                                <div className="btn-group mr-2" role="group" aria-label="Second group">
                                    <button
                                        className="btn btn-danger btn-sm"
                                        onClick={handleDeleteTimeTimeModel}>
                                        Tagesmodell löschen
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                        </td>
                        <td>
                            <div className="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
                                <div className="btn-group mr-2" role="group" aria-label="First group">
                                    <button
                                        className="btn btn-primary btn-sm"
                                        onClick={this.onSchichtrad}>
                                        Schichtrad
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>
                            <button
                                className="btn btn-info btn-sm"
                                onClick={handleCloseModal}>
                                abbrechen
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </ReactModal>
        );
    }
}

export default MobileShiftPlanningDataForm;
